import type { QueryClient, QueryFunction, QueryKey } from '@tanstack/react-query';

export const REVIEW_FRESH_MS = 10 * 60_000;
export const REVIEW_WARM_IMAGES = 8;

const started = new Set<string>();

export function reviewImageUrls(html: string, first: readonly string[] = []): string[] {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const found = Array.from(doc.querySelectorAll('img[src]'), (img) => img.getAttribute('src') ?? '');
  return [...new Set([...first, ...found].filter((url) => /^https:\/\//i.test(url)))].slice(0, REVIEW_WARM_IMAGES);
}

export function prefetchReviewOnce<T>(
  client: QueryClient,
  query: { queryKey: QueryKey; queryFn: QueryFunction<T> },
  images: (data: T) => string[],
): void {
  const once = JSON.stringify(query.queryKey);
  if (started.has(once)) return;
  started.add(once);
  void client
    .prefetchQuery({ queryKey: query.queryKey, queryFn: query.queryFn, staleTime: REVIEW_FRESH_MS, cacheTime: REVIEW_FRESH_MS, retry: false })
    .then(() => {
      const data = client.getQueryData<T>(query.queryKey);
      if (data === undefined || typeof Image === 'undefined') return;
      for (const url of images(data)) new Image().src = url;
    })
    .catch(() => undefined);
}

export function resetReviewPrefetch(): void {
  started.clear();
}
